import React, { Dispatch, SetStateAction, useEffect, useState } from "react"

import { Provider } from "lib/types/generated/graphql-types"
import { PROVIDER_TYPE } from "lib/types/common"

import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "../../Ui/Messages/ErrorMessage"
import { ZaverConfigTableRow, getLoadingRow } from "./ZaverConfigTableRow"
import TableBlurLoading from "../../Ui/Table/TableBlurLoading"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  providers: Provider[]
  error: object | undefined
  setEditId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const ZaverConfigTable = ({ providers, setEditId, error, loading }: Props) => {
  const [zaverProviders, setZaverProviders] = useState<Provider[]>([])

  useEffect(() => {
    if (providers) {
      setZaverProviders(providers?.filter((provider) => provider.type === PROVIDER_TYPE.ZAVER))
    }
  }, [providers])

  const tableHeader = (
    <TableHeader iconHeader={true}>
      <div>Identifier</div>
      <div>Base url</div>
      <div className="hideOnSmallScreens">Created</div>
      <div className="hideOnSmallScreens">Updated</div>
    </TableHeader>
  )

  if (loading)
    return <TableBlurLoading numberOfRows={2} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (zaverProviders?.length < 1)
    return (
      <EmptyList>
        <p> No configurations added</p>
      </EmptyList>
    )
  if (!providers) return null

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Zaver configurations. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...zaverProviders].map((provider) => (
          <ZaverConfigTableRow
            key={provider.id}
            id={provider.id}
            setEditId={setEditId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
